import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IBoostsState } from ".";

export enum BoostType {
}

export interface IUserBoost {
    type: BoostType;
    count: number;
}

export interface ILibBoost {
    id: number;
    name: string;
    description: string;
    count: number;
    cost: number;
}

export interface IUserBoostsResponse {
    userBoosts: IUserBoost[];
    lib: ILibBoost[];
}

export const getBoosts = createAsyncThunk<IUserBoostsResponse>(
    'getBoosts',
    async () => await api.boosts.getBoosts()
);

const getBoostsHandler = (builder: ActionReducerMapBuilder<IBoostsState>) => {
    builder
        .addCase(getBoosts.pending, (state: IBoostsState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(getBoosts.fulfilled, (state: IBoostsState, action: PayloadAction<IUserBoostsResponse>) => {
            state.loading = false;
            state.userBoosts = action.payload?.userBoosts ?? [];
            state.lib = action.payload?.lib ?? [];
        })
        .addCase(getBoosts.rejected, (state: IBoostsState) => {
            state.loading = false;
            state.error = 'Unable to get boosts';
        });
};

export default getBoostsHandler;